import { createValidator } from "not-valid";

// eslint-disable-next-line no-useless-escape
const ALLOWED_CHARACTERS_REGEX = /^[0-9\/\\-]*$/;
const VALID_CHARACTERS_ONLY = "Please use only numbers, forward slash, backward slash, and hyphens";

export const validMedicalValues = createValidator<string>((value: string) => {
    return ALLOWED_CHARACTERS_REGEX.test(value);
}, VALID_CHARACTERS_ONLY);
